window.addEventListener("DOMContentLoaded", () => {
  const input = document.getElementById("jobSearchInput") as HTMLInputElement;
  const dropdownToggle = document.getElementById("departmentDropdownToggle");
  const dropdownMenu = document.getElementById("departmentDropdownMenu");
  const checkboxes = document.querySelectorAll<HTMLInputElement>(".department-checkbox");
  const rows = document.querySelectorAll<HTMLTableRowElement>(".job-row");

  if (!input || !dropdownToggle || !dropdownMenu) return;

  // Toggle dropdown visibility & chevron state
  dropdownToggle.addEventListener("click", (e) => {
    e.stopPropagation(); // so our outside click handler doesn’t immediately close it
    const isHidden = dropdownMenu.classList.toggle("hidden");
    // if hidden=true, menu is now hidden, so remove .open; else add .open
    dropdownToggle.classList.toggle("open", !isHidden);
  });

  // Close dropdown when clicking outside
  document.addEventListener("click", (event) => {
    if (
      !dropdownToggle.contains(event.target as Node) &&
      !dropdownMenu.contains(event.target as Node)
    ) {
      // hide menu and reset chevron
      dropdownMenu.classList.add("hidden");
      dropdownToggle.classList.remove("open");
    }
  });

  const filterJobs = (clearSearch: boolean = false): void => {
    if (clearSearch) {
      input.value = "";
    }
    const filter = input.value.toLowerCase();
    const selectedDepts = Array.from(checkboxes)
      .filter((cb) => cb.checked)
      .map((cb) => cb.value.toLowerCase());

    rows.forEach((row) => {
      const title = row.dataset.title?.toLowerCase() || "";
      const city = row.dataset.city?.toLowerCase() || "";
      const department = row.dataset.department?.toLowerCase() || "";

      const matchesText = title.includes(filter) || city.includes(filter);
      const matchesDept = selectedDepts.length === 0 || selectedDepts.includes(department);

      row.style.display = matchesText && matchesDept ? "" : "none";
    });
  };

  input.addEventListener("input", () => filterJobs(false));
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", () => filterJobs(false));
  });
});
